import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import css from '../../css/sidebar/roomList.module.scss';
import sidebarCss from '../../css/sidebar/sidebar.module.scss';
import { ReactComponent as Lock } from '../../img/common/lock.svg';
import { ReactComponent as Mice } from '../../img/common/mice.svg';
import { ChatGroup } from '../../model/chatGroup';
import { ChatGroupRoom } from '../../model/chatGroupRoom';
import { selectRoom } from '../../slice/chatGroupSlice';
import { selectUser } from '../../slice/userSlice';
import { JoinPopup } from '../common/joinPopup';

type RoomListProps = {
    group: ChatGroup;
    room: ChatGroupRoom;
};

export const RoomList: React.FC<RoomListProps> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const room = props.room;
    const isRoomOnCall = room.members.length > 0;
    const { entity: user } = useSelector(selectUser);

    const isJoined = room.members.map((m) => m.id).includes(user ? user.id : -1);

    const roomElement = (
        <div className={css.list}>
            <Mice height="16" width="16" fill={isRoomOnCall ? '#48D040' : '#73706F'} style={{ marginRight: 4 }} />
            <JoinPopup group={props.group} room={props.room} trigger={<p>{room.name}</p>} />
            {isRoomOnCall && (
                <span style={{ backgroundColor: '#48D040' }} className={sidebarCss.mark}>
                    {room.members.length}人
                </span>
            )}
            {room.isLock && (
                <Lock
                    height={16}
                    width={16}
                    fill={'#F6C359'}
                    role="img"
                    aria-label="ロックされています"
                    style={{ marginRight: 16 }}
                />
            )}
        </div>
    );
    const joinedRoomElement = (
        <div className={css.list}>
            <Mice height="16" width="16" fill="#F14D38" />
            <p
                onClick={() => {
                    history.push(`/groups/${props.group.id}/rooms/${props.room.id}`);
                    dispatch(selectRoom({ group: props.group, room: props.room }));
                }}
            >
                {room.name}
            </p>
            <span style={{ backgroundColor: '#f14d38' }} className={sidebarCss.mark}>
                通話中
            </span>
            {room.isLock && (
                <Lock
                    height={16}
                    width={16}
                    fill={'#F6C359'}
                    role="img"
                    aria-label="ロックされています"
                    style={{ marginRight: 16 }}
                />
            )}
        </div>
    );

    return <>{isJoined ? joinedRoomElement : roomElement}</>;
};
